<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card flat class="no-display">
            <br>
            <v-row class="row" dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <p class="pl-2 mb-2"><b>Leave Academic Year</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="leave_academic_year"
                        :items="leave_academic_year_list" item-text="ay" item-value="id" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p class="pl-2 mb-2"><b>Month</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_month" :items="month_list"
                        item-text="name" item-value="id" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p class="pl-2 mb-2"><b>Employee Type</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" @change="getSections"
                        :items="employee_type_list" item-text="name" item-value="id" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p class="pl-2 mb-2"><b>Employee Section</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-select rounded required v-model="selected_section" :items="section_list" item-text="name" dense
                        item-value="id" outlined multiple @change="getEmployeeFromSection()" :loading="emp_loading">

                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="selected_all_section" @change="toggle_section()">
                                        <template #label><span class="ml-8">Select All</span>
                                        </template>
                                    </v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="selected_section">
                    <p class="pl-2 mb-2"><b>Employee</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_employee"
                        :items="employee_list" item-text="name" item-value="id" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p class="pl-2 mb-2"><b>Leave Type</b><v-icon class="mb-2 ml-2" color="error">*</v-icon></p>
                    <v-select rounded required v-model="selected_leave_type" :items="leave_type_list" item-text="type"
                        dense item-value="id" outlined multiple>

                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="selected_all_leave_types" @change="toggle_leave_type()">
                                        <template #label><span class="ml-8">Select All</span>
                                        </template>
                                    </v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="2" md="2" style="align-content: center;"
                    v-if="selected_section && selected_month && selected_leave_type">
                    <v-btn color="mb-2 button" :loading="loader" @click="fetchMonthlyLeaveDataReport()"
                        class="mt-2 button">Fetch
                        Report</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="monthly_leave_data.length > 0">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line background-color="white"
                    hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-btn small rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'Monthly_Leave_Data_Report')" class="mr-4">
                    <v-icon color="success">mdi-export</v-icon>Export
                </v-btn>
                <v-btn small outlined color="warning" @click="print()" rounded>
                    <v-icon left>mdi-printer</v-icon> Print
                </v-btn>
            </v-toolbar>

            <div id="my-table-id" v-if="monthly_leave_data.length > 0">
                <v-simple-table fixed-header dense class="elevation-1 leave-table">
                    <thead>
                        <tr>
                            <th class="text-center">Sr. No.</th>
                            <th class="text-center">Employee Code & Name</th>
                            <th class="text-center">Employee Type</th>
                            <th class="text-center">Leave Type</th>
                            <th class="text-center">Leaves Taken Till Previous Month</th>
                            <th class="text-center">Leaves Taken in Current Month</th>
                            <th class="text-center">Total Availed Leaves</th>
                            <th class="text-center">Total Balance Leaves</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(s, index) in filteredMonthlyLeaveDataReportList" :key="'row-' + index">
                            <td class="text-center">{{ s.sr_no }}</td>
                            <td class="text-center">{{ s.employee }}</td>
                            <td class="text-center">{{ s.employee_type }}</td>
                            <td class="text-center">{{ s.leave_type }}</td>
                            <td class="text-center">{{ s.till_prev_month }}</td>
                            <td class="text-center">{{ s.current_month }}</td>
                            <td class="text-center">{{ s.total_availed }}</td>
                            <td class="text-center">{{ s.balance }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>


            </div>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: null,
        leave_academic_year: "",
        selected_month: "",
        selected_leave_type: "",
        employee_type: null,
        selected_section: "",
        selected_employee: "",
        selected_all_section: false,
        selected_all_leave_types: false,
        emp_loading: false,
        leave_academic_year_list: [],
        month_list: [],
        leave_type_list: [],
        employee_type_list: [],
        section_list: [],
        employee_list: [],
        monthly_leave_data: [],
        loader: false,
    }),
    computed: {
        filteredMonthlyLeaveDataReportList() {
            if (!this.search) {
                return this.monthly_leave_data;
            }
            const searchTerm = this.search.toLowerCase();
            return this.monthly_leave_data.filter(item => {
                return (
                    item.employee.toLowerCase().includes(searchTerm) ||
                    item.leave_type.toLowerCase().includes(searchTerm) ||
                    item.employee_type.toLowerCase().includes(searchTerm)
                );
            });
        }
    },
    mounted() {
        this.onLoad();
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text =
                tab_text +
                "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text =
                tab_text +
                "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text =
                tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName =
                name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getSections() {
            const data = {
                empType: this.employee_type,
            };
            axios
                .post("/Payroll/getEmpSectionByEmpType", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.section_list = res.data.section_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        toggle_section() {
            this.$nextTick().then(() => {
                if (this.selected_all_section) {
                    this.selected_section = [];
                    for (var x in this.section_list) {
                        this.selected_section.push(this.section_list[x].id);
                    }
                    this.getEmployeeFromSection();
                } else {
                    this.selected_section = [];
                }
            });
        },
        getEmployeeFromSection() {
            if (this.selected_section.length == 0) {
                this.employee_list = [];
                return;
            }
            const data = {
                section_ids: this.selected_section,
            };
            this.emp_loading = true;
            axios.post("/Payroll/getEmployeeByEmpSection", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.employee_list = res.data.employee_list;
                    this.emp_loading = false;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    this.emp_loading = false;
                }
            });
        },
        toggle_leave_type() {
            this.$nextTick().then(() => {
                if (this.selected_all_leave_types) {
                    this.selected_leave_type = [];
                    for (var x in this.leave_type_list) {
                        this.selected_leave_type.push(this.leave_type_list[x].id);
                    }
                } else {
                    this.selected_leave_type = [];
                }
            });
        },
        fetchMonthlyLeaveDataReport() {
            const data = {
                leave_academic_year: this.leave_academic_year,
                selected_month: this.selected_month,
                employee: this.selected_employee,
                selected_section: this.selected_section,
                selected_leave_type: this.selected_leave_type,
            };
            this.loader = true;
            axios.post("/LeaveManagement/fetchMonthlyLeaveDataReport", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.monthly_leave_data = res.data.monthly_leave_data;
                    this.loader = false;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    this.loader = false;
                }
            });
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/LeaveManagement/getLeaveBalanceData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.leave_academic_year_list = res.data.leave_academic_year_list;
                            this.leave_type_list = res.data.leave_type_list;
                            this.month_list = res.data.month_list;
                            this.section_list = res.data.section_list;
                            this.employee_type_list = res.data.employee_type_list;
                            this.leave_academic_year_list = res.data.leave_academic_year_list.filter(item => item.ay !== 'All');
                            this.leave_type_list = res.data.leave_type_list.filter(item => item.type !== 'All');
                            this.section_list = res.data.section_list.filter(item => item.name !== 'All');
                            this.leave_academic_year = res.data.clay.id || "";
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
<style scoped>
.leave-table {
    width: 100%;
    overflow: hidden;
}

.leave-table thead tr th {
    background: #f0872b !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    padding: 12px 16px !important;
    text-transform: uppercase;
    font-size: 13px;
    white-space: nowrap;
    border-right: 1px solid #e3e1e1 !important;
}

.leave-table tbody td {
    padding: 10px 14px !important;
    border-bottom: 1px solid #e3e1e1 !important;
    border-right: 1px solid #e3e1e1 !important;
    color: #333333 !important;
}


@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    body,
    html {
        margin: 0 !important;
        padding: 0 !important;
    }

    /* Remove Vuetify toolbar spacing and default margins */
    .v-toolbar,
    .toolbar {
        margin: 0 !important;
        padding: 0 !important;
        min-height: 0 !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        margin: 0px;
        size: 18.5in 19in;
    }

    .box {
        overflow-x: hidden;
        border: none !important;
    }
}
</style>